import {
  ChangeDetectionStrategy,
  Component,
  Optional,
  computed,
  input,
  model,
} from '@angular/core';
import { TranslocoDirective } from '@ngneat/transloco';
import { UntilDestroy } from '@ngneat/until-destroy';
import {
  InputNumberComponent,
  InputRadioGroupComponent,
} from '@pedix-workspace/angular-ui-form-reactive';
import { ControlContainer, FormsModule, NgForm } from '@angular/forms';
import { AlertComponent, TagComponent } from '@pedix-workspace/angular-ui-alert';
import { PaymentMethod, PaymentMethodType } from '@pedix-workspace/utils';
import { IconInfoComponent } from '@pedix-workspace/angular-ui-icons';

@UntilDestroy()
@Component({
    selector: 'pxw-end-order-payment-methods-fields',
    templateUrl: './end-order-payment-methods-fields.component.html',
    styleUrls: ['./end-order-payment-methods-fields.component.scss'],
    providers: [],
    changeDetection: ChangeDetectionStrategy.OnPush,
    imports: [
        TranslocoDirective,
        FormsModule,
        InputRadioGroupComponent,
        TagComponent,
        AlertComponent,
        IconInfoComponent,
        InputNumberComponent,
    ],
    viewProviders: [
        {
            provide: ControlContainer,
            deps: [[Optional, NgForm]],
            useFactory: (ngForm: NgForm) => ngForm,
        },
    ]
})
export class EndOrderPaymentMethodsFieldsComponent {
  readonly paymentMethods = input.required<PaymentMethod[]>();

  readonly isFormSubmitted = input<boolean>(false);
  readonly orderFinalAmount = input<number>();
  readonly displayLinkInfo = input<boolean>(false);
  readonly displayHowMuchField = input<boolean>(false);

  readonly paymentMethod = model.required<PaymentMethod | null>();
  readonly howMuch = model.required<number | null>();

  readonly shouldDisplayHowMuchField = computed(
    () =>
      this.displayHowMuchField() &&
      this.paymentMethod()?.type === PaymentMethodType.CASH &&
      this.paymentMethod()?.displayCashPaymentAmount,
  );
}
